import LicenseListSearched from './LicenseListSearched.container';
export default LicenseListSearched;
